import React, { useContext } from 'react';
import AdminSettingTabs from './AdminSettingTabs';
import ROUTES from '../../config/Routes';
import { RoleBasedAccessControlContext } from '../../services/common/RolesUtils';
import { Context } from '../../states/Store';
import { useHistory } from 'react-router';
import { ADMIN_TABS_ID, useIframeAnnounce } from './AdminSettingsUtils';
import { getEnv } from '@ea-webapp/commons/utils';

const AdminSettingsEmbeddable = () => {
  const { isSigUser } = React.useContext(RoleBasedAccessControlContext);
  const [state] = useContext(Context);
  const history = useHistory();

  if (!isSigUser) {
    history.push(`/${state.account.id}/${ROUTES.ADMIN}?tab=attributes`);
  }

  const sigUrls = getEnv('REACT_APP_SIG_APP_URLS');
  const allowedOrigins = sigUrls ? sigUrls.split(',') : [];

  useIframeAnnounce(ADMIN_TABS_ID, allowedOrigins);

  return <AdminSettingTabs />;
};

export default AdminSettingsEmbeddable;
